import { render, staticRenderFns } from "./Footer.vue?vue&type=template&id=7ffaab02&scoped=true"
import script from "./Footer.vue?vue&type=script&lang=js"
export * from "./Footer.vue?vue&type=script&lang=js"
import style0 from "./Footer.vue?vue&type=style&index=0&id=7ffaab02&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ffaab02",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {LayoutWavesBackgroundTop: require('/home/leodev/Sistemas/loja/components/Layout/WavesBackgroundTop.vue').default})
